export default "__VITE_ASSET__Br1Me6Do__"